@import '@pexip/components/design-tokens/variables.scss';
@import '@pexip/components/design-tokens/mixins/media-queries.scss';

.headerEnhancer {
    @include mobile {
        margin-top: all-size(3);
    }
}

.enhancerStart {
    margin-inline-start: all-size(4);

    @include mobile {
        margin-inline-start: all-size(3);
    }
}

.enhancerEnd {
    margin-inline-end: all-size(4);

    @include mobile {
        margin-inline-end: all-size(3);
    }
}
